/* eslint-disable */

const env = {
    env: 'prod',
};

module.exports = env;


